import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-DWQNDXPYSS'; // Votre ID de mesure Google

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Vérifie si la fonction gtag est disponible (elle l'est grâce au script dans index.html)
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
        page_title: document.title
      });
    }
  }, [location]); // L'effet se déclenche à chaque changement de 'location'

  return null; // Ce composant ne rend rien visuellement
};

export default AnalyticsTracker;